import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { FilterService } from 'src/app/services/filter.service';
import { AppPermissions } from '../../app.permissions';

@Component({
  selector: 'ness-geographic-filter-status',
  templateUrl: './geographic-filter-status.component.html',
  styles: [':host-context(.d-flex.flex-wrap) { display: flex !important; flex-wrap: wrap !important;}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeographicFilterStatusComponent  {
  fieldDivisionName$: Observable<string> = this.filterService.fieldDivisionName$.asObservable();
  groupNameList$: Observable<string> = this.filterService.groupNameList$.asObservable();
  stateName$: Observable<string> = this.filterService.stateName$.asObservable();
  countyNameList$: Observable<string> = this.filterService.countyNameList$.asObservable();
  agencyNamesList$: Observable<string> = this.filterService.agencyNameList$.asObservable();

  readonly canViewGeoFilters = AppPermissions.canViewCrimeGunsList;

  private _hasLinkedAgencies: boolean = false;
  set hasLinkedAgenices(b: boolean) {
    this._hasLinkedAgencies = b;
  }
  get hasLinkedAgencies(): boolean {
    return this._hasLinkedAgencies;
  }


  constructor(private filterService: FilterService, private authService: AuthService) {
    this._hasLinkedAgencies = filterService.hasLinkedAgencies || this.authService.hasUserType(['ATFFieldDivision', 'ATFHQ']);
  }
}
